import {
    TableContainer,
    Table,
    TableRow,
    TableCell,
    TableHead,
    TableBody,
    Paper
} from '@mui/material';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { useState } from 'react';
import { endpoints } from '../../api/endpoints';
import { Actions } from '../../components/table/TableActions';
import { DeleteAlertModal } from '../../components/modal/DeleteAlertModal';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { TablePagination } from '../../components/pagination/Pagination';

export default function UserMangTable({ refetchData, loading, count, setSkip, setTake, take, skip, setSelectedItem, setOpen, rows }: { refetchData: any, loading: any, take: any, skip: any, setSkip: any, setTake: any, count: any, setOpen: any, setSelectedItem: any, rows: any }) {

    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [selectedId, setSelectedID] = useState<any | null>();

    const onSuccess = () => {
        setOpenAlertModal(false)
        setSelectedID(null)
        refetchData()
    }

    const onError = () => {
        setOpenAlertModal(false)
        setSelectedID(null)
    }

    const deleteAction = (row: any) => {
        setSelectedID(row.id);
        setOpenAlertModal(true)
    }
    const editAction = (row: any) => {
        setSelectedItem(row)
        setOpen(true)
    }

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 460 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableHeadCell align='center'>S.N</TableHeadCell>
                                <TableHeadCell>FullName</TableHeadCell>
                                <TableHeadCell>Branch</TableHeadCell>
                                <TableHeadCell>Username</TableHeadCell>
                                <TableHeadCell>Emp Id</TableHeadCell>
                                <TableHeadCell>Role</TableHeadCell>
                                <TableHeadCell>Designation</TableHeadCell>
                                <TableHeadCell align="center">Actions </TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!rows || loading ? <TableRowsLoader rowsNum={5} colNum={8} />
                                : rows.length <= 0 ? <TableRow><TableCell align="center" colSpan={8}>No data found</TableCell></TableRow>
                                    : rows?.map((row: any, index: number) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }} align='center'>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }}>{row.fullName}</TableCell>
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }}>{row.branchName}</TableCell>
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }}>{row.userName}</TableCell>
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }}>{row.empID}</TableCell>
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }}>{row.roleId === 0 ? "Maker" : row.roleId === 1 ? "Checker" : row.roleId === 2 ? "Admin" : null}</TableCell>
                                            <TableCell style={{ padding: '8px 4px', fontSize: "12px" }}>{row.designationName}</TableCell>
                                            <TableCell align="center" style={{ padding: '8px 4px', fontSize: "12px" }}>
                                                <Actions onDelete={deleteAction} onEdit={editAction} row={row} />
                                            </TableCell>
                                        </TableRow>
                                    ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
            </Paper>
            <DeleteAlertModal
                onSuccess={onSuccess}
                onError={onError}
                endpoint={endpoints.user.delete}
                selectedId={selectedId}
                openAlertModal={openAlertModal}
                setOpenAlertModal={setOpenAlertModal}
            />
        </>
    )
}
